export default __webpack_public_path__ + "static/media/discover.bd3c56b1.svg";